import React from "react";

import {addNotification} from "../state/notifications_slice";

export const addSuccessNotification = (message: string | React.JSX.Element, timeout?: number) =>
    addNotification({
        notification: {content: message, type: "success"},
        timeout
    });
import React from "react";

import {addNotification} from "../state/notifications_slice";

export const addSuccessNotification = (message: string | React.JSX.Element, timeout?: number) =>
    addNotification({
        notification: {content: message, type: "success"},
        timeout
    });
